/* TinaR – citire automată din „Dimensiuni” / descriere (adăugat 9 oct 2026).
   Reguli: măsurile pe lat se dublează; baza = mărimea pe care e măsurat/o poartă modelul, altfel M (27 la blugi);
   ±4 cm bust/talie/șold și ±1,5 cm lungime pe treaptă; mărimi combinate = o treaptă; EU 34,36… = o treaptă la 2 numere.
   12 oct 2026: croiala din titlu/tag (oversize; larg/lejer/vaporos; „mânecă largă” nu contează) și tag „talie-joasa”.
   Elasticitate: tag „elastic” = mare (orice produs); din Compoziție, doar la rochii/bluze etc. (nu fuste/pantaloni,
   nu jachete/sacouri/veste/trenciuri/paltoane – 13 oct 2026): elastan/spandex/lycra ≥ 4% = mare, sub 4% = medie.
   13 oct 2026: vestele, jachetele și cardiganele din tricot („tricot”/„tricotat”/„cardigan” în titlu) se tratează ca pulovere.
   13 oct 2026: tag „curea” = talia se poate strânge cu cureaua (vezi tinar-fit.js).
   13 oct 2026: tag „talie-elastica” = elastic + curea; „bine” până la talie produs − 10 cm (larg sub), strâmt peste talie produs + 10 cm;
   mesajul „Talia e elastică și se așază pe corp.” Cu „talie-elastica” + „curea”: „bine” până la talie produs − 15 cm,
   mesajul „Talia e elastică și se poate ajusta cu cureaua.” */
(function () {
  "use strict";
  var LET = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL"];
  function n(s) { var v = parseFloat(String(s).replace(",", ".")); return isFinite(v) ? v : null; }
  function norm(s) { return String(s || "").toUpperCase().replace(/\s+/g, "").replace("3XL", "XXXL"); }
  function grab(seg, re) { var m = seg.match(re); return m ? [n(m[1]), m[2] ? n(m[2]) : null] : [null, null]; }
  function findBase(text, sizes) {
    var res = [
      /m[aă]surat[e]?\s+(?:pe|pentru)\s+m[aă]rimea\s+([A-Z0-9\/]+)/i,
      /pentru\s+m[aă]rimea\s+([A-Z0-9\/]+)/i,
      /dimensiuni[^:]{0,30}\(\s*m[aă]rime(?:a)?\s+([A-Z0-9\/]+)\s*\)/i,
      /poart[aă]\s+m[aă]rimea\s+([A-Z0-9\/]+(?:\s*\(\s*[A-Z]+\s*\))?)/i
    ];
    for (var i = 0; i < res.length; i++) {
      var m = text.match(res[i]); if (!m) continue;
      var cand = norm(m[1]).replace(/[()]/g, "/").split("/").filter(Boolean);
      var whole = norm(m[1]).replace(/\(.*\)/, "");
      for (var j = 0; j < sizes.length; j++) if (norm(sizes[j]) === whole) return sizes[j];
      for (var k = 0; k < cand.length; k++) for (j = 0; j < sizes.length; j++) if (norm(sizes[j]) === cand[k]) return sizes[j];
    }
    var pref = ["M", "27", "38"];
    for (i = 0; i < pref.length; i++) for (j = 0; j < sizes.length; j++) if (norm(sizes[j]) === pref[i]) return sizes[j];
    for (j = 0; j < sizes.length; j++) if (norm(sizes[j]).split("/").indexOf("M") >= 0) return sizes[j];
    return sizes[Math.floor((sizes.length - 1) / 2)];
  }
  function steps(sizes, base) {
    var out = {}, i0 = sizes.indexOf(base);
    if (sizes.some(function (s) { return s.indexOf("/") >= 0; })) { sizes.forEach(function (s, i) { out[s] = i - i0; }); return out; }
    if (sizes.every(function (s) { return LET.indexOf(norm(s)) >= 0; })) {
      var b = LET.indexOf(norm(base)); sizes.forEach(function (s) { out[s] = LET.indexOf(norm(s)) - b; }); return out;
    }
    var nums = sizes.map(function (s) { return parseInt(s, 10); });
    if (nums.some(isNaN)) { sizes.forEach(function (s, i) { out[s] = i - i0; }); return out; }
    var jeans = nums.some(function (x) { return x % 2; }) || Math.min.apply(null, nums) < 32, bb = parseInt(base, 10);
    sizes.forEach(function (s) { out[s] = Math.round((parseInt(s, 10) - bb) / (jeans ? 1 : 2)); });
    return out;
  }
  function parse(d) {
    var text = String(d.text || "").replace(/<[^>]+>/g, " ").replace(/&nbsp;/g, " ");
    var full = text;
    text = text.replace(/(dimensiuni(?:le)?\s+model(?:ului)?|model\s*:\s*[îi]n[aă]l[tţț]ime)[\s\S]*$/i, "");
    var start = text.search(/(lungime[^:]{0,20}|bust|talie|[sSșȘşŞ]old(?:uri)?)\s*:\s*\d/i);
    if (start < 0) return [];
    var rest = text.slice(start), end = rest.search(/model/i);
    var seg = end > 0 ? rest.slice(0, end) : rest;
    var L = grab(seg, /lungime[^:]{0,20}:\s*(\d+(?:[.,]\d+)?)/i)[0],
        B = grab(seg, /bust\s*:\s*(\d+(?:[.,]\d+)?)/i)[0],
        T = grab(seg, /talie\s*:\s*(\d+(?:[.,]\d+)?)(?:\s*[–-]\s*(\d+(?:[.,]\d+)?))?/i),
        S = grab(seg, /[sSșȘşŞ]old(?:uri)?\s*:\s*(\d+(?:[.,]\d+)?)/i)[0];
    var Tm = T[1]; T = T[0];
    if (B && B < 70) B *= 2; if (S && S < 70) S *= 2; if (T && T < 50) T *= 2; if (Tm && Tm < 50) Tm *= 2;
    if (!B && !T && !S) return [];
    var sizes = (d.sizes || []).filter(Boolean);
    if (sizes.length <= 1) return [{ size: sizes[0] || "", tip: d.tip, bust: B, talie: T, talie_max: Tm, sold: S, lungime: L }];
    var base = findBase(full, sizes), st = steps(sizes, base);
    return sizes.map(function (s) {
      var k = st[s] || 0, add = function (v) { return v ? v + 4 * k : null; };
      return { size: s, tip: d.tip, bust: add(B), talie: add(T), talie_max: add(Tm), sold: add(S), lungime: L ? L + 1.5 * k : null };
    });
  }
  window.TinarFitParse = parse;
})();
/* Pregătește datele pentru tinar-fit.js: dacă nu există corecții (items), le construiește din text. */
(function () {
  function plain(s) { return String(s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""); }
  function flags(d) {
    var t = plain(d.title).replace(/man(eca|eci|ecile)\s+(larg|lejer|ampl)\w*/g, "");
    var tags = (d.tags || []).map(function (x) { return String(x).toLowerCase().trim(); });
    var cro = (tags.indexOf("oversize") >= 0 || /oversiz/.test(t)) ? "oversize"
      : (tags.indexOf("lejer") >= 0 || /\b(larg|lejer|vaporo)/.test(t)) ? "lejera" : "";
    var comp = plain(d.comp);
    var mE = comp.match(/(\d+(?:[.,]\d+)?)\s*%\s*(elastan|spandex|lycra|elastomer)/);
    var pct = mE ? parseFloat(mE[1].replace(",", ".")) : (/elastan|spandex|lycra/.test(comp) ? 2 : 0);
    var knit = /^(vest|cardigan|jachet)/.test(plain(d.tip)) && /tricot|cardigan/.test(plain(d.title));
    var outer = !knit && /^(jachet|sacou|vest|trench|palton|cardigan)/.test(plain(d.tip));
    var bottom = /^(fust|pantalon|jeans|blugi)/.test(plain(d.tip)) || outer;
    var tel = tags.indexOf("talie-elastica") >= 0, cur = tags.indexOf("curea") >= 0;
    var el = (tags.indexOf("elastic") >= 0 || tel) ? "mare" : (!bottom && pct >= 4) ? "mare" : (!bottom && pct > 0) ? "medie" : "";
    return { cro: cro, joasa: tags.indexOf("talie-joasa") >= 0, el: el, knit: knit, curea: cur || tel, tel: tel, cur: cur };
  }
  function run() {
    document.querySelectorAll("[data-tinar-fit]").forEach(function (box) {
      var el = box.querySelector("[data-tinar-fit-json]"); if (!el) return;
      var d; try { d = JSON.parse(el.textContent); } catch (e) { return; }
      var parsed = d.text ? window.TinarFitParse(d) : [];
      if (!d.items) d.items = parsed;
      else if (parsed.length) {   /* corecțiile au prioritate; mărimile lipsă se completează din text */
        var have = {}; d.items.forEach(function (i) { have[i.size] = i; });
        d.items = parsed.map(function (p) { return have[p.size] || p; });
      }
      var f = flags(d);
      (d.items || []).forEach(function (i) {
        if (f.knit) i.tip = "pulover";
        if (f.cro && !i.croiala) i.croiala = f.cro;
        if (f.el && !i.elasticitate) i.elasticitate = f.el;
        if (f.joasa) i.talie_joasa = true;
        if (f.curea) i.curea = true;
        if (f.tel && f.cur) { i.talie_msg = "Talia e elastică și se poate ajusta cu cureaua."; i.curea_tol = 10; }
        else if (f.tel) { i.talie_msg = "Talia e elastică și se așază pe corp."; i.curea_tol = 5; }
      });
      delete d.text; delete d.comp; el.textContent = JSON.stringify(d);
      var ok = (d.items || []).some(function (i) { return i.bust || i.talie || i.sold; });
      if (ok) box.removeAttribute("hidden");
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run); else run();
})();
